// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Quotation_container__l4wnD {
  display: flex;
  flex-direction: column;
  align-self: center;
  width: 100%;
  align-items: center;
}

.Quotation_upper__oJrcy {
  display: grid;
  grid-template-columns: 72rem 1.5fr;
  gap: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Quotation_upper__oJrcy {
    grid-template-columns: 60rem 1fr;
  }
}
@media only screen and (max-width: 56.25em) {
  .Quotation_upper__oJrcy {
    grid-template-columns: 100%;
  }
}
.Quotation_upper__ql__1kBEX {
  width: 100%;
  border-radius: 2rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.5rem 2rem;
  height: -moz-fit-content;
  height: fit-content;
  align-self: center;
}
@media only screen and (max-width: 56.25em) {
  .Quotation_upper__ql__1kBEX {
    width: 95%;
    justify-self: center;
  }
}
.Quotation_upper__ql__content__VyePU {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-sizing: border-box;
  gap: 2rem;
  margin-top: 3rem;
}
.Quotation_upper__multiple__fzfNT {
  display: flex;
  flex-direction: column;
  border-radius: 2rem;
  background-color: var(--color-white);
  padding: 2rem;
}
.Quotation_upper__metrics__WS\\+Tj {
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 1rem;
}
@media only screen and (max-width: 62.5em) {
  .Quotation_upper__metrics__WS\\+Tj {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 56.25em) {
  .Quotation_upper__metrics__WS\\+Tj {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .Quotation_upper__metrics__WS\\+Tj {
    grid-template-columns: repeat(2, 1fr);
  }
}
.Quotation_upper__metrics_paid__zJUy8 {
  background-color: var(--color-green);
  color: var(--color-white);
}
.Quotation_upper__metrics_unpaid__GUZWM {
  background-color: var(--color-error);
  color: var(--color-white);
}
.Quotation_upper__metrics_partPaid__F9m5r {
  background-color: var(--color-yellow);
}
.Quotation_upper__metrics_vat__F7284 {
  background-color: var(--color-light-red);
}
.Quotation_upper__metrics_discount__GAUIH {
  background-color: var(--color-primary-7);
}
.Quotation_upper__metrics_due__G2i2r {
  background-color: var(--color-error);
  color: var(--color-white);
}
.Quotation_upper__metrics_owe__hHo3U {
  background-color: var(--color-error);
  color: var(--color-white);
}

.Quotation_searchInMiddle__R0Pc3 {
  display: flex;
  width: 100%;
  justify-content: center;
}

.Quotation_invoice__list__NKEix {
  margin-top: 2rem;
  display: flex;
  position: relative;
}
.Quotation_invoice__beside__WwzGg {
  display: flex;
  justify-content: space-between;
  width: 38rem;
  flex-wrap: wrap;
}
.Quotation_invoice__checks__ETmaX {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
  width: 38rem;
}
.Quotation_invoice__checks_group__ykDZP {
  align-self: center;
  width: 38rem;
}

.Quotation_table__iWuay {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.Quotation_table__iWuay th,
.Quotation_table__iWuay td {
  padding: 2.2rem 0;
}
.Quotation_table__iWuay th {
  font-weight: 700;
}
.Quotation_table__iWuay tr {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 7rem 1fr 1fr;
  padding: 0 3rem;
}
@media only screen and (max-width: 37.5em) {
  .Quotation_table__iWuay tr {
    grid-template-columns: 20% 50% 30%;
  }
}
.Quotation_table__iWuay tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Quotation_table__iWuay tbody tr {
  background-color: var(--color-primary-3);
  border-radius: 1.3rem;
}
.Quotation_table__iWuay tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
}
.Quotation_table__iWuay tbody tr > :last-child {
  display: flex;
  justify-content: space-between;
  font-size: var(--default-font-size);
}
@media only screen and (max-width: 37.5em) {
  .Quotation_table__iWuay tbody tr > :last-child {
    font-size: var(--default-font-small);
  }
}
.Quotation_table__iWuay tbody tr > :last-child > * {
  cursor: pointer;
}
.Quotation_table__iWuay tbody tr > :last-child > *:hover {
  color: var(--color-primary);
}
.Quotation_table__iWuay tbody tr > :nth-child(5) {
  font-size: 3rem;
  position: relative;
}
.Quotation_table__iWuay tbody tr > :nth-child(5) span {
  font-size: 1.2rem;
  width: -moz-fit-content;
  width: fit-content;
  background-color: rgba(0, 0, 0, 0.75);
  color: var(--color-white);
  position: absolute;
  padding: 0.5rem;
  left: -1.6rem;
  border-radius: 0.5rem;
  text-align: center;
  opacity: 0;
  cursor: pointer;
}
.Quotation_table__iWuay tbody tr > :nth-child(5) span:hover {
  opacity: 1;
}

.Quotation_notPaid__vCoV1 {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
  position: relative;
  top: 1rem;
}

.Quotation_partPaid__YSfdR {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  margin-bottom: 1rem;
  width: 83%;
}

.Quotation_paid__uMnTG {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-green);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
}

.Quotation_minMenu__ZF8Z1 {
  color: var(--color-primary);
  cursor: pointer;
  font-size: 2rem;
}

.Quotation_sideButton__JWh\\+J {
  display: flex;
  margin-top: 3rem;
}

.Quotation_summary__hqyBR {
  width: 42rem;
  margin-top: 2rem;
}
.Quotation_summary__title__7IsmR {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Quotation_summary__initials__qLBVg {
  display: flex;
  background-color: var(--color-fash-primary);
  font-size: var(--default-font-h3);
  font-weight: 700;
  width: 8rem;
  height: 8rem;
  border-radius: 8rem;
  justify-content: center;
  align-items: center;
}
.Quotation_summary__edit__FmZvx {
  display: flex;
  align-items: flex-end;
  color: var(--color-dark);
  font-size: var(--default-font-small);
  cursor: pointer;
  margin-bottom: 3rem;
}
.Quotation_summary__edit__FmZvx > :last-child {
  font-size: 3rem;
  color: var(--color-fash-primary-3);
}
.Quotation_summary__edit__FmZvx:hover, .Quotation_summary__edit__FmZvx:focus {
  color: var(--color-fash-primary-3);
  font-weight: 700;
}
.Quotation_summary__line__2J0mQ {
  border-top: 1px solid var(--color-dark);
  margin: 2rem 0;
  width: 38rem;
}
.Quotation_summary__dates__2nEZG {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.Quotation_summary__dates__2nEZG > :not(:last-child) {
  margin-right: 2rem;
}
.Quotation_summary__total__bNg2T {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 2rem;
  margin-bottom: 1rem;
}
.Quotation_summary__account__da\\+kO {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 1rem;
  margin: 2rem 0;
}
.Quotation_summary__button__UDSW3 {
  display: flex;
  gap: 2rem;
  align-items: center;
  margin-top: 2rem;
}

.Quotation_error__fVsCZ {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
}

.Quotation_select__im3E1 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 38rem;
  margin-bottom: 3rem;
  cursor: pointer;
}
.Quotation_select__im3E1 > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.Quotation_select__invoice__luZrh {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Quotation_select__invoice_b__S69J7 {
  border: 1px solid var(--color-primary);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Quotation_select__receipt__rqDAp {
  border: 1px solid var(--color-primary);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}
.Quotation_select__receipt_b__ndxFq {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}

.Quotation_selectCurrency__sTMD4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--default-font-small);
  position: relative;
  margin-left: 2rem;
}
.Quotation_selectCurrency__text__lnNI5 {
  display: flex;
  margin-left: 1rem;
}
.Quotation_selectCurrency__icon__2YZTt {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transform: rotateZ(0);
  transition-duration: 500ms;
}
.Quotation_selectCurrency__icon__2YZTt:hover {
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Quotation_selectCurrency__icon_active__2pExs {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transition-duration: 500ms;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Quotation_selectCurrency__list__aceSd {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 5rem;
  background-color: #f2f0f0;
  color: var(--color-dark);
  border-radius: 1rem;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  position: absolute;
  top: 6rem;
  z-index: 30;
  border: solid 1px var(--color-primary-4);
}
.Quotation_selectCurrency__list_active__UqGLB {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}
.Quotation_selectCurrency__list__aceSd li {
  list-style: none;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 1rem;
  cursor: pointer;
}
.Quotation_selectCurrency__list__aceSd li:hover {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Quotation/Quotation.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,kCAAA;EACA,SAAA;AADF;AAGE;EALF;IAMI,gCAAA;EAAF;AACF;AAEE;EATF;IAUI,2BAAA;EACF;AACF;AAOE;EACE,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,kBAAA;AALJ;AAOI;EAVF;IAWI,UAAA;IACA,oBAAA;EAJJ;AACF;AAMI;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAJN;AAQE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;AANJ;AASE;EACE,sBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAPJ;AASI;EARF;IASI,qCAAA;EANJ;AACF;AAQI;EAZF;IAaI,qCAAA;EALJ;AACF;AAOI;EAhBF;IAiBI,qCAAA;EAJJ;AACF;AAMI;EACE,oCAAA;EACA,yBAAA;AAJN;AAOI;EACE,oCAAA;EACA,yBAAA;AALN;AAQI;EACE,qCAAA;AANN;AASI;EACE,wCAAA;AAPN;AAUI;EACE,wCAAA;AARN;AAWI;EACE,oCAAA;EACA,yBAAA;AATN;AAYI;EACE,oCAAA;EACA,yBAAA;AAVN;;AAeA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;AAZF;;AAgBE;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;AAbJ;AAgBE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AAdJ;AAiBE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,YAAA;AAfJ;AAiBI;EACE,kBAAA;EACA,YAAA;AAfN;;AAiCA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AA9BF;AAgCE;;EAEE,iBAAA;AA9BJ;AAiCE;EACE,gBAAA;AA/BJ;AAkCE;EACE,aAAA;EACA,mDAAA;EACA,eAAA;AAhCJ;AAkCI;EALF;IAMI,kCAAA;EA/BJ;AACF;AAmCI;EACE,qBAAA;AAjCN;AAoCI;EACE,wCAAA;EACA,qBAAA;AAlCN;AAoCM;EACE,wCAAA;AAlCR;AAqCM;EACE,aAAA;EACA,8BAAA;EACA,mCAAA;AAnCR;AAoCQ;EAJF;IAKI,oCAAA;EAjCR;AACF;AAmCQ;EACE,eAAA;AAjCV;AAkCU;EACE,2BAAA;AAhCZ;AAqCM;EAWE,eAAA;EACA,kBAAA;AA7CR;AA+CQ;EACE,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AA7CV;AA+CU;EACE,UAAA;AA7CZ;;AAqDA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;AAlDF;;AAqDA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,mBAAA;EACA,UAAA;AAlDF;;AAqDA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AAlDF;;AAqDA;EACE,2BAAA;EACA,eAAA;EACA,eAAA;AAlDF;;AAsDA;EACE,aAAA;EACA,gBAAA;AAnDF;;AAuDA;EACE,YAAA;EACA,gBAAA;AApDF;AAqDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAnDJ;AAsDE;EACE,aAAA;EACA,2CAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AApDJ;AAuDE;EACE,aAAA;EACA,qBAAA;EACA,wBAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;AArDJ;AAuDI;EACE,eAAA;EACA,kCAAA;AArDN;AAwDI;EAEE,kCAAA;EACA,gBAAA;AAvDN;AA2DE;EACE,uCAAA;EACA,cAAA;EACA,YAAA;AAzDJ;AA4DE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA1DJ;AA2DI;EACE,kBAAA;AAzDN;AA6DE;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,mBAAA;AA3DJ;AA8DE;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,cAAA;AA5DJ;AA+DE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AA7DJ;;AAmEA;EACE,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAhEF;;AAmEA;EACE,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EAEA,mBAAA;EACA,eAAA;AAjEF;AAmEE;EACE,sBAAA;EACA,kBAAA;AAjEJ;AAoEE;EACE,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAlEJ;AAoEI;EACE,sCAAA;EACA,4BAAA;EACA,oBAAA;AAlEN;AAsEE;EACE,sCAAA;EACA,4BAAA;EACA,oBAAA;AApEJ;AAsEI;EACE,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AApEN;;AAyEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AAtEF;AAwEE;EACE,aAAA;EACA,iBAAA;AAtEJ;AAyEE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AAvEJ;AAyEI;EACE,4DACE;EAEF,wCAAA;EACA,2BAAA;AAzEN;AA4EI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;EACA,4DACE;EAEF,wCAAA;EACA,2BAAA;AA5EN;AAgFE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4DACE;EAEF,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wCAAA;AAhFJ;AAkFI;EACE,wCAAA;EACA,2BAAA;EACA,gBAAA;AAhFN;AAmFI;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAjFN;AAmFM;EACE,wCAAA;EACA,2BAAA;EACA,gBAAA;AAjFR","sourcesContent":["@import \"../variables/breakpoints\";\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  width: 100%;\n  align-items: center;\n}\n\n.upper {\n  display: grid;\n  grid-template-columns: 72rem 1.5fr;\n  gap: 2rem;\n\n  @media only screen and (max-width: $bp-1000) {\n    grid-template-columns: 60rem 1fr;\n  }\n\n  @media only screen and (max-width: $bp-900) {\n    grid-template-columns: 100%;\n  }\n\n  // &__search {\n  // \tgrid-column: 1/3;\n  // \tgrid-row: 1/2;\n  // \tjustify-self: center;\n  // }\n\n  &__ql {\n    width: 100%;\n    border-radius: 2rem;\n    background-color: var(--color-white);\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    box-sizing: border-box;\n    padding: 3.5rem 2rem;\n    height: fit-content;\n    align-self: center;\n\n    @media only screen and (max-width: $bp-900) {\n      width: 95%;\n      justify-self: center;\n    }\n\n    &__content {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-evenly;\n      box-sizing: border-box;\n      gap: 2rem;\n      margin-top: 3rem;\n    }\n  }\n\n  &__multiple {\n    display: flex;\n    flex-direction: column;\n    border-radius: 2rem;\n    background-color: var(--color-white);\n    padding: 2rem;\n  }\n\n  &__metrics {\n    box-sizing: border-box;\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n    margin-bottom: 1rem;\n\n    @media only screen and (max-width: $bp-1000) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    @media only screen and (max-width: $bp-900) {\n      grid-template-columns: repeat(3, 1fr);\n    }\n\n    @media only screen and (max-width: $bp-600) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    &_paid {\n      background-color: var(--color-green);\n      color: var(--color-white);\n    }\n\n    &_unpaid {\n      background-color: var(--color-error);\n      color: var(--color-white);\n    }\n\n    &_partPaid {\n      background-color: var(--color-yellow);\n    }\n\n    &_vat {\n      background-color: var(--color-light-red);\n    }\n\n    &_discount {\n      background-color: var(--color-primary-7);\n    }\n\n    &_due {\n      background-color: var(--color-error);\n      color: var(--color-white);\n    }\n\n    &_owe {\n      background-color: var(--color-error);\n      color: var(--color-white);\n    }\n  }\n}\n\n.searchInMiddle {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n}\n\n.invoice {\n  &__list {\n    margin-top: 2rem;\n    display: flex;\n    position: relative;\n  }\n\n  &__beside {\n    display: flex;\n    justify-content: space-between;\n    width: 38rem;\n    flex-wrap: wrap;\n  }\n\n  &__checks {\n    display: flex;\n    justify-content: space-between;\n    margin: 1rem 0 2rem 0;\n    width: 38rem;\n\n    &_group {\n      align-self: center;\n      width: 38rem;\n    }\n  }\n}\n\n// .status {\n// \tcontent: none;\n// \twidth: 50%;\n// \tborder-radius: 1rem;\n// \tbackground-color: var(--color-yellow);\n// \tjustify-self: center;\n// \talign-self: center;\n// \tpadding: 3rem;\n// \tdisplay: block;\n// }\n\n//Table styles start\n\n.table {\n  width: 100%;\n  max-width: 100%;\n  border: none;\n  border-collapse: collapse;\n  box-sizing: border-box;\n  text-align: left;\n  font-size: var(--default-font-small);\n\n  th,\n  td {\n    padding: 2.2rem 0;\n  }\n\n  th {\n    font-weight: 700;\n  }\n\n  tr {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr 7rem 1fr 1fr;\n    padding: 0 3rem;\n\n    @media only screen and (max-width: $bp-600) {\n      grid-template-columns: 20% 50% 30%;\n    }\n  }\n\n  tbody {\n    & > :not(:last-child) {\n      margin-bottom: 1.5rem;\n    }\n\n    tr {\n      background-color: var(--color-primary-3);\n      border-radius: 1.3rem;\n\n      &:nth-child(even) {\n        background-color: var(--color-primary-7);\n      }\n\n      & > :last-child {\n        display: flex;\n        justify-content: space-between;\n        font-size: var(--default-font-size);\n        @media only screen and (max-width: $bp-600) {\n          font-size: var(--default-font-small);\n        }\n\n        & > * {\n          cursor: pointer;\n          &:hover {\n            color: var(--color-primary);\n          }\n        }\n      }\n\n      & > :nth-child(5) {\n        // content: none;\n        // width: 3rem;\n        // height: 3rem;\n        // border-radius: 0.8rem;\n\n        // justify-self: center;\n        // align-self: center;\n        // padding: 0;\n        // margin-left: -2rem;\n\n        font-size: 3rem;\n        position: relative;\n\n        span {\n          font-size: 1.2rem;\n          width: fit-content;\n          background-color: rgba(0, 0, 0, 0.75);\n          color: var(--color-white);\n          position: absolute;\n          padding: 0.5rem;\n          left: -1.6rem;\n          border-radius: 0.5rem;\n          text-align: center;\n          opacity: 0;\n          cursor: pointer;\n\n          &:hover {\n            opacity: 1;\n          }\n        }\n      }\n    }\n  }\n}\n\n.notPaid {\n  display: inline-flex;\n  justify-content: center;\n  line-height: 1;\n  font-size: 1rem;\n  border-radius: 1rem;\n  background-color: var(--color-error);\n  color: var(--color-white);\n  margin-bottom: 1rem;\n  width: 83%;\n  position: relative;\n  top: 1rem;\n}\n\n.partPaid {\n  display: inline-flex;\n  justify-content: center;\n  line-height: 1;\n  font-size: 1rem;\n  border-radius: 1rem;\n  background-color: var(--color-yellow);\n  color: var(--color-dark);\n  margin-bottom: 1rem;\n  width: 83%;\n}\n\n.paid {\n  display: inline-flex;\n  justify-content: center;\n  line-height: 1;\n  font-size: 1rem;\n  border-radius: 1rem;\n  background-color: var(--color-green);\n  color: var(--color-white);\n  margin-bottom: 1rem;\n  width: 83%;\n}\n\n.minMenu {\n  color: var(--color-primary);\n  cursor: pointer;\n  font-size: 2rem;\n}\n//Table styles end\n\n.sideButton {\n  display: flex;\n  margin-top: 3rem;\n}\n\n//Summary Styles\n.summary {\n  width: 42rem;\n  margin-top: 2rem;\n  &__title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  &__initials {\n    display: flex;\n    background-color: var(--color-fash-primary);\n    font-size: var(--default-font-h3);\n    font-weight: 700;\n    width: 8rem;\n    height: 8rem;\n    border-radius: 8rem;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &__edit {\n    display: flex;\n    align-items: flex-end;\n    color: var(--color-dark);\n    font-size: var(--default-font-small);\n    cursor: pointer;\n    margin-bottom: 3rem;\n\n    & > :last-child {\n      font-size: 3rem;\n      color: var(--color-fash-primary-3);\n    }\n\n    &:hover,\n    &:focus {\n      color: var(--color-fash-primary-3);\n      font-weight: 700;\n    }\n  }\n\n  &__line {\n    border-top: 1px solid var(--color-dark);\n    margin: 2rem 0;\n    width: 38rem;\n  }\n\n  &__dates {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 2rem;\n    & > :not(:last-child) {\n      margin-right: 2rem;\n    }\n  }\n\n  &__total {\n    display: grid;\n    grid-template-columns: 1.3fr 1fr;\n    gap: 2rem;\n    margin-bottom: 1rem;\n  }\n\n  &__account {\n    display: grid;\n    grid-template-columns: 1.3fr 1fr;\n    gap: 1rem;\n    margin: 2rem 0;\n  }\n\n  &__button {\n    display: flex;\n    gap: 2rem;\n    align-items: center;\n    margin-top: 2rem;\n  }\n}\n\n//Errors\n\n.error {\n  font-size: var(--default-font-small);\n  color: var(--color-error);\n  padding-left: 2rem;\n  font-weight: 400;\n  margin: 1rem 0;\n}\n\n.select {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  box-sizing: border-box;\n  font-size: var(--default-font-small);\n  width: 38rem;\n\n  margin-bottom: 3rem;\n  cursor: pointer;\n\n  & > * {\n    padding: 1rem 0 1rem 0;\n    text-align: center;\n  }\n\n  &__invoice {\n    background-color: var(--color-primary);\n    color: var(--color-white);\n    border-radius: 1rem 0 0 1rem;\n    transition: all 0.4s;\n\n    &_b {\n      border: 1px solid var(--color-primary);\n      border-radius: 1rem 0 0 1rem;\n      transition: all 0.4s;\n    }\n  }\n\n  &__receipt {\n    border: 1px solid var(--color-primary);\n    border-radius: 0 1rem 1rem 0;\n    transition: all 0.4s;\n\n    &_b {\n      background-color: var(--color-primary);\n      color: var(--color-white);\n      border-radius: 0 1rem 1rem 0;\n      transition: all 0.4s;\n    }\n  }\n}\n\n.selectCurrency {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: var(--default-font-small);\n  position: relative;\n  margin-left: 2rem;\n\n  &__text {\n    display: flex;\n    margin-left: 1rem;\n  }\n\n  &__icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 3rem;\n    background-color: #f2f0f0;\n    color: var(--color-primary);\n    width: 5rem;\n    height: 5rem;\n    border-radius: 5rem;\n    border: solid 1px var(--color-primary-4);\n    cursor: pointer;\n    transform: rotateZ(0);\n    transition-duration: 500ms;\n\n    &:hover {\n      box-shadow:\n        10px 10px 45px #bebebe,\n        -15px -15px 30px #ffffff;\n      background-color: var(--color-primary-3);\n      transform: rotateZ(-180deg);\n    }\n\n    &_active {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 3rem;\n      background-color: #f2f0f0;\n      color: var(--color-primary);\n      width: 5rem;\n      height: 5rem;\n      border-radius: 5rem;\n      border: solid 1px var(--color-primary-4);\n      cursor: pointer;\n      transition-duration: 500ms;\n      box-shadow:\n        10px 10px 45px #bebebe,\n        -15px -15px 30px #ffffff;\n      background-color: var(--color-primary-3);\n      transform: rotateZ(-180deg);\n    }\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-sizing: border-box;\n    width: 5rem;\n    background-color: #f2f0f0;\n    color: var(--color-dark);\n    border-radius: 1rem;\n    box-shadow:\n      10px 10px 45px #bebebe,\n      -15px -15px 30px #ffffff;\n    position: absolute;\n    top: 6rem;\n    z-index: 30;\n    border: solid 1px var(--color-primary-4);\n\n    &_active {\n      background-color: var(--color-primary-7);\n      color: var(--color-primary);\n      font-weight: 700;\n    }\n\n    li {\n      list-style: none;\n      display: flex;\n      justify-content: center;\n      width: 100%;\n      padding: 1rem 0;\n      box-sizing: border-box;\n      border-radius: 1rem;\n      cursor: pointer;\n\n      &:hover {\n        background-color: var(--color-primary-7);\n        color: var(--color-primary);\n        font-weight: 700;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Quotation_container__l4wnD`,
	"upper": `Quotation_upper__oJrcy`,
	"upper__ql": `Quotation_upper__ql__1kBEX`,
	"upper__ql__content": `Quotation_upper__ql__content__VyePU`,
	"upper__multiple": `Quotation_upper__multiple__fzfNT`,
	"upper__metrics": `Quotation_upper__metrics__WS+Tj`,
	"upper__metrics_paid": `Quotation_upper__metrics_paid__zJUy8`,
	"upper__metrics_unpaid": `Quotation_upper__metrics_unpaid__GUZWM`,
	"upper__metrics_partPaid": `Quotation_upper__metrics_partPaid__F9m5r`,
	"upper__metrics_vat": `Quotation_upper__metrics_vat__F7284`,
	"upper__metrics_discount": `Quotation_upper__metrics_discount__GAUIH`,
	"upper__metrics_due": `Quotation_upper__metrics_due__G2i2r`,
	"upper__metrics_owe": `Quotation_upper__metrics_owe__hHo3U`,
	"searchInMiddle": `Quotation_searchInMiddle__R0Pc3`,
	"invoice__list": `Quotation_invoice__list__NKEix`,
	"invoice__beside": `Quotation_invoice__beside__WwzGg`,
	"invoice__checks": `Quotation_invoice__checks__ETmaX`,
	"invoice__checks_group": `Quotation_invoice__checks_group__ykDZP`,
	"table": `Quotation_table__iWuay`,
	"notPaid": `Quotation_notPaid__vCoV1`,
	"partPaid": `Quotation_partPaid__YSfdR`,
	"paid": `Quotation_paid__uMnTG`,
	"minMenu": `Quotation_minMenu__ZF8Z1`,
	"sideButton": `Quotation_sideButton__JWh+J`,
	"summary": `Quotation_summary__hqyBR`,
	"summary__title": `Quotation_summary__title__7IsmR`,
	"summary__initials": `Quotation_summary__initials__qLBVg`,
	"summary__edit": `Quotation_summary__edit__FmZvx`,
	"summary__line": `Quotation_summary__line__2J0mQ`,
	"summary__dates": `Quotation_summary__dates__2nEZG`,
	"summary__total": `Quotation_summary__total__bNg2T`,
	"summary__account": `Quotation_summary__account__da+kO`,
	"summary__button": `Quotation_summary__button__UDSW3`,
	"error": `Quotation_error__fVsCZ`,
	"select": `Quotation_select__im3E1`,
	"select__invoice": `Quotation_select__invoice__luZrh`,
	"select__invoice_b": `Quotation_select__invoice_b__S69J7`,
	"select__receipt": `Quotation_select__receipt__rqDAp`,
	"select__receipt_b": `Quotation_select__receipt_b__ndxFq`,
	"selectCurrency": `Quotation_selectCurrency__sTMD4`,
	"selectCurrency__text": `Quotation_selectCurrency__text__lnNI5`,
	"selectCurrency__icon": `Quotation_selectCurrency__icon__2YZTt`,
	"selectCurrency__icon_active": `Quotation_selectCurrency__icon_active__2pExs`,
	"selectCurrency__list": `Quotation_selectCurrency__list__aceSd`,
	"selectCurrency__list_active": `Quotation_selectCurrency__list_active__UqGLB`
};
export default ___CSS_LOADER_EXPORT___;
